import React, { useEffect, useState } from 'react'
import { useCalc } from '../../context/CalcContext'

const TYPICAL_DILUTION = 0.2
const DILUTION_AT = 24

const DilutionType = (props) => {
  const { procent = true } = props
  const { dataSetRunwayNew, runwayWithout, runwayWith } = useCalc()
  const [dilutionAvoided, setDilutionAvoided] = useState(0)
  const [amount, setAmount] = useState(10)

  useEffect(() => {
    if (
      dataSetRunwayNew &&
      dataSetRunwayNew.companyFinancialsWithoutFejron &&
      dataSetRunwayNew.companyFinancialsWithoutFejron.length >= DILUTION_AT
    ) {
      const dilutionWithoutFejron =
        1 -
        dataSetRunwayNew.companyFinancialsWithoutFejron[DILUTION_AT]
          .founder_ownership

      const dilutionWithoutMarketing =
        1 -
        dataSetRunwayNew.companyFinancialsWithoutExtraMarketing[DILUTION_AT]
          .founder_ownership

      const dilutionWithMarketing =
        1 -
        dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing[DILUTION_AT]
          .founder_ownership

      const reducedDilution = {
        withMarketing: 1 - dilutionWithMarketing / dilutionWithoutFejron,
        withoutMarketing: 1 - dilutionWithoutMarketing / dilutionWithoutFejron
      }
      // console.log('dilutionWithoutFejron', dilutionWithoutFejron)
      // console.log('dilutionWithoutMarketing', dilutionWithoutMarketing)
      // console.log('reducedDilution', reducedDilution)
      if (reducedDilution.withMarketing > reducedDilution.withoutMarketing) {
        const valuation =
          dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing[
            DILUTION_AT
          ].valuation

        // round((Q11-Q13)*Q30/10^4)*10^4

        const amount =
          Math.round(
            ((dilutionWithoutFejron - dilutionWithMarketing) * valuation) / 1000
          ) * 1000

        setAmount(amount)
        setDilutionAvoided(reducedDilution.withMarketing)
      } else {
        const valuation =
          dataSetRunwayNew.companyFinancialsWithoutExtraMarketing[DILUTION_AT]
            .valuation
        const amount =
          Math.floor(
            ((dilutionWithoutFejron - dilutionWithoutMarketing) * valuation) /
              1000
          ) * 1000
        setAmount(amount)
        setDilutionAvoided(
          reducedDilution.withoutMarketing
            ? reducedDilution.withoutMarketing
            : 1
        )
      }
    }

    //
  }, [dataSetRunwayNew, runwayWith, runwayWithout])

  useEffect(() => {}, [dilutionAvoided])

  //console.log('founder ownership', founderOwnsership)

  return procent ? (
    <>{Math.round(dilutionAvoided * 100)}%</>
  ) : (
    <>(~€{Math.round(amount / 100000) / 10} million)</>
  )
}

export default DilutionType
